import { AnimatePresence, motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useState } from 'react';
import thumbnail from '@/assets/vsl-thumbnail.webp';
import { FadeIn } from '@/components';

export function VslVideo() {
  const [isPlaying, setIsPlaying] = useState(false);

  const videoId = 'ZiyAziLa9kQ';
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;

  return (
    <section className="section-shell bg-muted/40">
      {/* Subtle radial glow */}
      <div className="pointer-events-none absolute top-1/2 left-1/2 hidden h-200 w-200 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/8 blur-[120px] sm:block" />

      <div className="section-container">
        <div className="section-header max-w-4xl">
          <FadeIn direction="up" distance={20}>
            <p className="mb-3 font-mono text-xs tracking-[0.25em] text-primary/70 uppercase">
              Registro de Voo
            </p>
            <h2 className="section-title">
              Veja o Método <br />
              <span className="text-primary" id="vsl">
                em Ação no Campo
              </span>
            </h2>
            <p className="section-description">
              Em poucos minutos, o Eduardo explica como funciona a formação e o que muda na sua
              carreira como piloto agrícola.
            </p>
          </FadeIn>
        </div>

        {/* Video Container */}
        <FadeIn direction="up" distance={30} delay={0.2}>
          <div className="group relative mx-auto max-w-5xl">
            {/* Decorative frame glow */}
            <div className="absolute -inset-px hidden bg-linear-to-r from-primary/30 via-primary/10 to-primary/30 opacity-25 blur-sm transition duration-1000 group-hover:opacity-50 sm:block" />

            <div className="relative aspect-video overflow-hidden border border-border bg-black shadow-2xl dark:border-white/10">
              {/* HUD overlays on thumbnail */}
              {!isPlaying && (
                <div className="pointer-events-none absolute top-4 left-4 z-20 flex items-center gap-2 sm:top-5 sm:left-5">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
                  </span>
                  <span className="font-mono text-[10px] tracking-widest text-red-400/80 uppercase">
                    REC
                  </span>
                </div>
              )}

              <AnimatePresence mode="wait">
                {!isPlaying ? (
                  <motion.div
                    key="thumbnail"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="relative w-full h-full"
                  >
                    <img
                      src={thumbnail}
                      alt="Assista ao vídeo de apresentação do curso"
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100"
                    />

                    <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/20 to-transparent pointer-events-none" />

                    {/* Play Button */}
                    <button
                      type="button"
                      onClick={() => setIsPlaying(true)}
                      className="absolute inset-0 flex items-center justify-center transition-all duration-300"
                    >
                      <div className="relative">
                        <motion.div
                          animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
                          transition={{ duration: 2, repeat: Infinity }}
                          className="absolute inset-0 bg-primary/40 rounded-full blur-xl"
                        />
                        <div className="relative flex h-16 w-16 items-center justify-center border-2 border-primary/50 bg-primary/20 backdrop-blur-sm shadow-[0_0_50px_rgba(16,185,129,0.3)] transition-transform duration-300 group-hover:scale-110 md:h-24 md:w-24">
                          <Play className="ml-1 h-7 w-7 fill-white text-white md:ml-1.5 md:h-10 md:w-10" />
                        </div>
                      </div>
                    </button>

                    {/* Bottom label */}
                    <div className="absolute right-4 bottom-4 hidden items-center gap-2 border border-white/10 bg-black/60 px-4 py-2 backdrop-blur-md sm:flex sm:right-5 sm:bottom-5">
                      <span className="font-mono text-[10px] font-bold tracking-widest text-white/70 uppercase">
                        Vídeo de Apresentação
                      </span>
                    </div>
                  </motion.div>
                ) : (
                  <motion.div
                    key="video"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="w-full h-full"
                  >
                    <iframe
                      src={embedUrl}
                      title="Apresentação Guri dos Drones"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="w-full h-full border-0"
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
